/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useState } from 'react';

import MarketingStore from '../MarketingStore';
import Footer from './Footer';
import Header from './Header/Header';
import * as styles from './Layout.module.scss';

function htmlReplace(a, b, element) {
  if (!element) element = document.body;
  let nodes = element.childNodes;
  for (let n = 0; n < nodes.length; n++) {
    if (nodes[n].nodeType === Node.TEXT_NODE) {
      let r = new RegExp(a, 'gi');
      nodes[n].textContent = nodes[n].textContent.replace(r, b);
    } else {
      htmlReplace(a, b, nodes[n]);
    }
  }
}

const Layout = ({
  isBlog,
  displayCta,
  hideNav = false,
  onCtaClick,
  children,
  background = '',
  className = '',
  pageMeta = null,
  footerClassName = '',
  noNav = false,
  smoothScroll = true,
  isDach = false,
  noFooter = false,
}) => {
  let bgColor;
  let isDark = false;
  switch (background) {
    case 'grey': {
      bgColor = styles.bgGrey;
      break;
    }
    case 'black': {
      bgColor = styles.bgBlack;
      isDark = true;
      break;
    }
    case 'blue': {
      bgColor = styles.bgBlue;
      break;
    }
    case 'customDark': {
      bgColor = styles.bgCustomDark;
      break;
    }
    case 'evergreen deep': {
      bgColor = styles.bgEvergreenDeep;
      break;
    }
    default: {
      bgColor = '';
      break;
    }
  }

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const [hashed, setHash] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && !hashed) {
      const { hash } = window.location;

      // gsc.tab is added by Google for site search
      if (!hash || hash.includes('gsc.tab')) return;

      window.requestAnimationFrame(async () => {
        await setHash(true);
        const anchor = document.querySelector(hash);
        if (!anchor) return;
        const offset = anchor.getBoundingClientRect().top + window.scrollY - 84;

        window.scroll({ top: offset, left: 0, behavior: smoothScroll ? 'smooth' : 'auto' });
      });
    }
  }, [hashed, smoothScroll]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.host.indexOf('fullstory') > -1) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        branch: process.env.BRANCH || 'production',
      });
    }
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    htmlReplace(/\u2028/g, '');
    const scripts = document.querySelectorAll('script[type="module"]');

    if (scripts) {
      for (const script of scripts) {
        script.setAttribute('data-ot-ignore', 'true');
      }
    }
  }, []);

  // TODO: Note - removing data-branch={process.env.BRANCH} that was used for split branch testing.
  //  causing warnings.
  //  Add back as GATSBY_BRANCH next time its needed

  return (
    <div
      className={[className, styles.page, bgColor].join(' ')}
      style={{
        '--adaptiveGrey': isDark ? 'rgba(250, 250, 250, 0.1)' : '#fafafa',
        '--adaptiveTextColor': isDark ? 'white' : 'black',
      }}
    >
      {typeof window !== 'undefined' && window.location.hostname.indexOf('fullstory.com') > -1 && (
        <noscript>
          <iframe
            title={'cheq4ppc'}
            src="https://obs.yougreencolumn.com/ns/412fd4bd52ce85743bbb7810b6cec0c0.html?ch=cheq4ppc"
            width="0"
            height="0"
            style={{ display: 'none' }}
          ></iframe>
        </noscript>
      )}
      <MarketingStore />
      {!noNav && (
        <Header
          className={'standard-header'}
          hideNav={hideNav}
          displayCta={displayCta}
          onCtaClick={onCtaClick}
          isBlog={isBlog}
          siteTitle={data.site.siteMetadata.title}
          pageMeta={pageMeta}
          isDach={isDach}
        />
      )}
      <div id="layout-body" className={styles.layoutBody}>
        <main>{children}</main>
        {!noFooter && <Footer className={footerClassName} />}
      </div>
    </div>
  );
};

export const BACKGROUND = {
  WHITE: 'white',
  GREY: 'grey',
  BLACK: 'black',
  BLUE: 'blue',
  CUSTOMDARK: 'customDark',
};

export default Layout;
